module.exports = __webpack_public_path__ + "img/tear-off-calendar.2924aa47.png";